import { render, staticRenderFns } from "./AddPayments.vue?vue&type=template&id=f1fa552e&scoped=true"
import script from "./AddPayments.vue?vue&type=script&lang=js"
export * from "./AddPayments.vue?vue&type=script&lang=js"
import style0 from "./AddPayments.vue?vue&type=style&index=0&id=f1fa552e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fa552e",
  null
  
)

export default component.exports